"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mockAmbassador = void 0;
const species_1 = require("./species");
const user_1 = require("./user");
function mockAmbassador(overrides = {}) {
    return {
        image: 'https://example.com/20190329161749.jpg',
        slug: 'user_profile_slug',
        user: (0, user_1.mockUserPublic)(),
        location: 'mockville, USA',
        species: [(0, species_1.mockSpecies)()],
        ...overrides,
    };
}
exports.mockAmbassador = mockAmbassador;
